import React from 'react';
import { useEssentials } from '../../contexts/essentials-context';
import { Box, Text } from '@wix/design-system';
import { Badge } from '.';
import s from '../../sass/badge.module.scss';

export interface WixSaleBadgeProps {
  amount: string;
  size?: 'tiny' | 'small' | 'medium';
}
export function WixSaleBadge({ amount, size = 'small' }: WixSaleBadgeProps) {
  amount = Math.round(Number(amount)).toString();
  const { t, experiments } = useEssentials();

  const showNewWixSaleBadge =
    experiments?.enabled('specs.app-market.NewWixSaleBadge') ?? false;

  return (
    <Box marginTop="1px">
      <Badge
        skin="success"
        className={s.wixSaleBadge}
        dataHook="wix-sale-badge"
        uppercase={false}
        size={size}
        tooltipContent={
          <Box direction="vertical" gap="6px">
            {/* @ts-expect-error wds types are incompatible */}
            <Text size="small" weight="bold" skin="light">
              {t('wix.holiday.sale.badge')}
            </Text>
            {/* @ts-expect-error wds types are incompatible */}
            <Text size="small" weight="thin" skin="light">
              {t('wix.sale.badge.tooltip', { amount })}
            </Text>
          </Box>
        }
      >
        <Box className={s.wixSaleBadgeText} fontSize="small" marginTop="2px">
          {showNewWixSaleBadge
            ? t('wix.sale.badge.new', { amount })
            : t('wix.sale.badge', { amount })}
        </Box>
      </Badge>
    </Box>
  );
}
